import { Workspace } from '@/types';
import { api } from './client';

// ── Phase E — workspace members + invitations ───────────────────────────

export interface WorkspaceMemberItem {
  userId: string;
  name: string;
  email: string;
  role: 'OWNER' | 'ADMIN' | 'APPROVER' | 'MEMBER';
  joinedAt: string | null;
}

export interface WorkspaceInvitationItem {
  id: string;
  email: string;
  role: 'OWNER' | 'ADMIN' | 'APPROVER' | 'MEMBER';
  expiresAt: string;
  createdAt: string | null;
}

export interface InvitationPreview {
  workspaceName: string;
  inviterName: string;
  role: string;
  email: string;
  expiresAt: string;
}

export const memberApi = {
  list: (workspaceId: string) =>
    api.get<WorkspaceMemberItem[]>(`/api/workspaces/${workspaceId}/members`).then((r) => r.data),
  invite: (workspaceId: string, email: string, role: 'ADMIN' | 'APPROVER' | 'MEMBER') =>
    api
      .post<WorkspaceInvitationItem>(`/api/workspaces/${workspaceId}/members/invite`, {
        email,
        role,
      })
      .then((r) => r.data),
  remove: (workspaceId: string, targetUserId: string) =>
    api.delete<void>(`/api/workspaces/${workspaceId}/members/${targetUserId}`).then((r) => r.data),
  changeRole: (
    workspaceId: string,
    targetUserId: string,
    role: 'OWNER' | 'ADMIN' | 'APPROVER' | 'MEMBER',
  ) =>
    api
      .patch<WorkspaceMemberItem>(`/api/workspaces/${workspaceId}/members/${targetUserId}`, {
        role,
      })
      .then((r) => r.data),
};

export const invitationApi = {
  listPending: (workspaceId: string) =>
    api
      .get<WorkspaceInvitationItem[]>(`/api/workspaces/${workspaceId}/invitations`)
      .then((r) => r.data),
  revoke: (workspaceId: string, invitationId: string) =>
    api
      .delete<void>(`/api/workspaces/${workspaceId}/invitations/${invitationId}`)
      .then((r) => r.data),
};

/**
 * Public-ish invitation endpoints. The preview GET works without a JWT —
 * the user might not be signed in when they click the email link. The
 * accept POST requires auth.
 */
export const publicInviteApi = {
  preview: (token: string) =>
    api.get<InvitationPreview>(`/api/invitations/${token}`).then((r) => r.data),
  accept: (token: string) =>
    api.post<Workspace>(`/api/invitations/${token}/accept`, {}).then((r) => r.data),
};
